import { useTranslation } from 'react-i18next';
import { Form, Input } from 'antd';
import { CurrencyBadge } from '@/components/currency-badge';
import { getFieldState } from '@/utils/formUtils';
import { formValidateAndSetNumber } from '@/utils/inputApi';

export default function OtherColumns({ form, isEdited, formFields }) {
  const { t } = useTranslation(['forms']);

  return [
    {
      dataIndex: 'inputName',
      header: t('type', { ns: 'forms' }),
      render: (_, row) => {
        const { groupName, inputName } = row;

        const name = groupName ? [groupName, inputName] : inputName;

        const nameState = getFieldState({
          formFields,
          formKeys: name,
          isEdited,
        });

        return (
          <Form.Item
            label={row.inputLabel}
            name={name}
            className="!mb-0 whitespace-nowrap"
            labelCol={{
              className:
                '!pb-0 !h-[20px] [&_label]:!text-[13px] !whitespace-nowrap',
            }}
            rules={[
              {
                required: true,
                message: t('formValidation.numberField.invalid', {
                  ns: 'forms',
                }),
              },
            ]}
          >
            <Input
              min={0}
              type="number"
              step="any"
              size="small"
              className="h-7"
              placeholder={row.inputLabel}
              onChange={(e) => formValidateAndSetNumber(form, e, name, 0)}
              disabled={nameState?.disabled}
            />
          </Form.Item>
        );
      },
    },
    {
      dataIndex: 'currency',
      header: t('currency', { ns: 'forms' }),
      render: (value) => {
        return (
          <CurrencyBadge
            currency={value.label}
            currencyCode={value.currencyCode}
          />
        );
      },
    },
  ];
}
